import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const accommodationApi = createApi({
  reducerPath: "accommodationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/accommodations`,
  }),
  tagTypes: ["Accommodations"],
  endpoints: (builder) => ({
    getAccommodations: builder.query<any[], void>({
      query: () => "/",
      providesTags: ["Accommodations"],
    }),
    createAccommodation: builder.mutation<any, any>({
      query: (data) => ({ url: "/", method: "POST", body: data }),
      invalidatesTags: ["Accommodations"],
    }),
    updateAccommodation: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({ url: `/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["Accommodations"],
    }),
    deleteAccommodation: builder.mutation<any, string>({
      query: (id) => ({ url: `/${id}`, method: "DELETE" }),
      invalidatesTags: ["Accommodations"],
    }),
  }),
});

export const {
  useGetAccommodationsQuery,
  useCreateAccommodationMutation,
  useUpdateAccommodationMutation,
  useDeleteAccommodationMutation,
} = accommodationApi;
